module.exports = require("vue-clipboard2");